import React, { useRef } from 'react';
import { janela } from '../services/plataforma';
import LogoOrion from './LogoOrion';

// ─────────────────────────────────────────────────────────────────────────────
// Botão flutuante — o app recolhido.
//
// Mesma peça do Nexus: um disco de 60px dentro de uma janela de 68px que fica
// no canto inferior direito da tela, sempre por cima. Clicar expande; arrastar
// move a janela.
//
// A distinção entre clique e arrasto é por DISTÂNCIA (5px), não por tempo:
// quem arrasta o botão quase sempre solta o mouse em cima dele, e um teste por
// tempo abriria o app a cada reposicionamento.
// ─────────────────────────────────────────────────────────────────────────────

export default function BotaoFlutuante() {
  const arrasto = useRef({ arrastando: false, x: 0, y: 0 });

  const aoPressionar = (e) => {
    arrasto.current = { arrastando: true, x: e.screenX, y: e.screenY };
    janela.iniciarArrasto(e.screenX, e.screenY);

    const aoMover = (ev) => {
      if (!arrasto.current.arrastando) return;
      janela.arrastar(ev.screenX, ev.screenY);
    };
    const aoSoltar = () => {
      arrasto.current.arrastando = false;
      janela.pararArrasto();
      window.removeEventListener('mousemove', aoMover);
      window.removeEventListener('mouseup', aoSoltar);
    };

    window.addEventListener('mousemove', aoMover);
    window.addEventListener('mouseup', aoSoltar);
  };

  const aoClicar = (e) => {
    const dx = Math.abs(e.screenX - arrasto.current.x);
    const dy = Math.abs(e.screenY - arrasto.current.y);
    if (dx < 5 && dy < 5) janela.expandir();
  };

  return (
    <div
      className="floating-btn-wrap"
      onMouseDown={aoPressionar}
      onClick={aoClicar}
      title="Orion — clique para abrir"
    >
      <div className="floating-btn">
        <span className="floating-btn-icon"><LogoOrion size={60} /></span>
      </div>
    </div>
  );
}
